import Vuex from "vuex";
import Vue from "vue";
import Cookies from "js-cookie";
import user from "./modules/user";
// import permission from './modules/permission'
import menu from "./modules/menu";
import article from "./modules/article";
import config from "./modules/config";
import notification from "./modules/notification";

import template from "./modules/template";
import msgComment from "./modules/msgComment";

import getters from "./getters";

Vue.use(Vuex);

const state = {
  isMgr: false,
  // token: state => state.user.token,
  sidebar: {
    opened: true,
    // opened: !!+Cookies.get('sidebarStatus'),
    withoutAnimation: false
  },
  user: null,
  loading: false,
  templates: {},
  moduleName: "fnweb",
  $router: null,
  signalRConnection: null,
  connected: false
};

export default new Vuex.Store({
  state: state,
  mutations: {
    SET_MGR: (state, isMgr) => {
      state.isMgr = isMgr;
    },
    SET_MENU: (state, router) => {
      state.$menu = router;
    },
    SET_$ROUTER: (state, router) => {
      state.$router = router;
    },
    SET_$ROUTERS: (state, router) => {
      state.$routers = router;
    },
    LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_TEMPLATES: (state, { templates, name }) => {
      state.templates = Object.assign(state.templates, templates);
      if (name) {
        state.moduleName = name;
      }
    },
    TOGGLE_SIDEBAR: (state) => {
      if (state.sidebar.opened) {
        Cookies.set("sidebarStatus", 1);
      } else {
        Cookies.set("sidebarStatus", 0);
      }
      state.sidebar.opened = !state.sidebar.opened;
      state.sidebar.withoutAnimation = false;
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set("sidebarStatus", 1);
      state.sidebar.opened = false;
      state.sidebar.withoutAnimation = withoutAnimation;
    },
    SET_SIGNALR_CONNECTION(state, connection) {
      state.signalRConnection = connection;
    },
    SET_CONNECTED_STATUS(state, isConnected) {
      state.connected = isConnected;
    }
  },
  getters,
  actions: {
    setMenu({ commit }, router) {
      return new Promise((resolve, reject) => {
        commit("SET_MENU", router);
        resolve();
      });
    },
    goLogin({ commit, dispatch, state }) {
      return new Promise((resolve, reject) => {
        dispatch("LogOut").then(() => {
          state.$router.push({
            path: "/login",
            query: {
              redirect: location.pathname
            }
          });
          location.reload();
        });
      });
    },
    toggleSideBar({ commit }) {
      commit("TOGGLE_SIDEBAR");
    },
    closeSideBar({ commit }, { withoutAnimation }) {
      commit("CLOSE_SIDEBAR", withoutAnimation);
    },
    setSignalRConnection({ commit }, connection) {
      commit('SET_SIGNALR_CONNECTION', connection);
    },
    setConnectedStatus({ commit }, isConnected) {
      commit('SET_CONNECTED_STATUS', isConnected);
    }
  },
  modules: {
    user,
    // permission,
    notification,
    menu,
    config,
    article,
    template,
    msgComment
  }
});
